import { render, staticRenderFns } from "./DrawAmtInput.vue?vue&type=template&id=15a6b6fb&scoped=true"
import script from "./DrawAmtInput.vue?vue&type=script&lang=js"
export * from "./DrawAmtInput.vue?vue&type=script&lang=js"
import style0 from "./DrawAmtInput.vue?vue&type=style&index=0&id=15a6b6fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6b6fb",
  null
  
)

export default component.exports